import { BdaDataset } from "../models/BdaDataset";
import { KrakendCollection, PagedResults } from "../models/generics";
import client from "./axios";

const datasetsUrl = `${window.__env.KRAKEND_URL}/v1/datasets`;

export const Datasets = {
  getDatasets: (params?: URLSearchParams) => client.get<PagedResults<BdaDataset> | KrakendCollection<BdaDataset>>(datasetsUrl, { params }),
  getDataset: (id: number, params?: URLSearchParams) => client.get<BdaDataset>(`${datasetsUrl}/${id}`, { params }),
  createDataset: (dataset: BdaDataset, params?: URLSearchParams) => client.post<BdaDataset>(datasetsUrl, dataset, { params }),
  updateDataset: (dataset: BdaDataset) => client.put<BdaDataset>(`${datasetsUrl}/${dataset.id}`, dataset),
  deleteDataset: (id: number, params?: URLSearchParams) => client.delete(`${datasetsUrl}/${id}`, { params }),
  downloadDataset: (id: number) => client.get(`${datasetsUrl}/${id}/export`, { responseType: 'blob' }),
}